import { z } from "zod";
export const CSV_EXPORT_MAX_IDS = 2000;
export const CSV_EXPORT_MAX_BYTES = 25 * 1024 * 1024;
const id = z.string().trim().min(1).max(128);
const ids = z
    .array(id)
    .min(1)
    .max(CSV_EXPORT_MAX_IDS)
    .refine((value) => new Set(value).size === value.length, {
    message: "Resource IDs must be unique",
});
const filename = z
    .string()
    .trim()
    .min(1)
    .max(200)
    .refine((value) => !/[\u0000-\u001F\u007F-\u009F/\\]/.test(value), {
    message: "Invalid filename",
});
const workspaceRequest = {
    workspaceId: id,
    filename,
};
const decimalSeparator = z.enum(["comma", "dot"]);
const inventoryContentFilter = z.enum(["all", "consumption", "emissions"]);
export const CsvExportRequestSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("climate-actions"), ...workspaceRequest, ids, decimalSeparator }).strict(),
    z.object({ kind: z.literal("projects"), ...workspaceRequest, ids, decimalSeparator }).strict(),
    z.object({ kind: z.literal("tasks"), ...workspaceRequest, ids, decimalSeparator }).strict(),
    z.object({ kind: z.literal("indicator-values"), ...workspaceRequest, indicatorId: id, decimalSeparator }).strict(),
    z
        .object({ kind: z.literal("all-indicator-values"), ...workspaceRequest, ids: ids.optional(), decimalSeparator })
        .strict(),
    z
        .object({
        kind: z.literal("inventory-flat"),
        ...workspaceRequest,
        inventoryId: id,
        decimalSeparator,
        contentFilter: inventoryContentFilter.optional(),
        sectorTitle: z.string().trim().min(1).max(200).optional(),
    })
        .strict(),
    z
        .object({
        kind: z.literal("inventory-pivot"),
        ...workspaceRequest,
        inventoryId: id,
        decimalSeparator,
        contentFilter: z.enum(["consumption", "emissions"]),
    })
        .strict(),
    z.object({ kind: z.literal("scenarios"), ...workspaceRequest, scenarioModelId: id, ids, decimalSeparator }).strict(),
    z
        .object({
        kind: z.literal("scenario-comparison"),
        ...workspaceRequest,
        ids: ids.refine((value) => value.length >= 2 && value.length <= 6, { message: "Select 2 to 6 scenarios" }),
        metric: z.enum(["energy", "emission"]),
    })
        .strict(),
]);
